import { RegistrationType } from "../types";
import { NibudType } from "../types/orchestrator";

export const SENTRY_DSN: string = 'https://bd26a19fb7e84461a43acddd78019609@sentry.uncinc.nl/65';

export const REGISTRATION_TYPE_MOVING: RegistrationType = 'moving';
export const REGISTRATION_TYPE_RENOVATION: RegistrationType = 'renovation';

export const NIBUD_FLAT: NibudType = 'VKO_NIBUD_HEAT_FLAT';
export const NIBUD_2_ONDER_1_KAP: NibudType = 'VKO_NIBUD_HEAT_2_ONDER_1_KAP';
export const NIBUD_HOEKWONING: NibudType = 'VKO_NIBUD_HEAT_HOEKWONING';
export const NIBUD_TUSSENWONING: NibudType = 'VKO_NIBUD_HEAT_TUSSENWONING';
export const NIBUD_VRIJSTAAND: NibudType = 'VKO_NIBUD_HEAT_VRIJSTAAND';

export const USAGE_SLIDER_TIMEOUT = 200;
